const modalDiv = document.getElementById('modal');
var dialog;

var self;

export class Modal {// extends Component {
	constructor(options = {}){
		this.state = {
			isDragging: false,
			isHidden: true,
			xDiff: 0,
			yDiff: 0,
			x: 50,
			y: 50,
			width: 400,
			height: 300,
			title: '&nbsp;',
			html: '&nbsp;',
		};
		if(options.width !== undefined) this.state.width = options.width;
		if(options.height !== undefined) this.state.height = options.height;
		if(options.title !== undefined) this.state.title = options.title;
		if(options.html !== undefined) this.state.html = options.html;
		this.state.x = Math.round((document.documentElement.clientWidth - this.state.width)/2);
		this.state.y = Math.round((document.documentElement.clientHeight - this.state.height)/2);
		//super(options);
		self = this;
		//this.createModal();

	}

	createModal(){
		dialog = document.createElement('div');
		dialog.classList.add('modal_dialog');
		dialog.classList.add('resizable');
		dialog.setAttribute('id', 'modal_dialog');
		dialog.style.width = this.state.width + 'px';
		dialog.style.height = this.state.height + 'px';
		const dialogBar = document.createElement('div');
		dialogBar.classList.add('modal_bar');
		dialogBar.setAttribute('id', 'modal_bar');
		const dialogTitle = document.createElement('div');
		dialogTitle.classList.add('modal_title');
		dialogTitle.innerHTML = this.state.title;
		const dialogClose = document.createElement('span');
		dialogClose.classList.add('modal_close');
		dialogClose.innerHTML = '&#x2716';
		const dialogBody = document.createElement('div');
		dialogBody.classList.add('modal_body');
		dialogBody.innerHTML = this.state.html;
		
		modalDiv.appendChild(dialog);
		dialog.appendChild(dialogBar);
		dialog.appendChild(dialogBody);
		dialogBar.appendChild(dialogTitle);
		dialogBar.appendChild(dialogClose);
		
		ready(() => {
			this.renderWindow();

			dialogBar.addEventListener('mousedown', onMouseDown.bind(this));
			dialogBar.addEventListener('mousedown', onMouseDown.bind(this));
			document.addEventListener('mousemove', this.onMouseMove.bind(this));
			document.addEventListener('mouseup', onMouseUp.bind(this));

			var closeButton = document.querySelectorAll('.modal_close');
			dialogClose.addEventListener('click', this.hideModal.bind(this));
			modalDiv.addEventListener('click', this.hideEvent.bind(this));
		});
	}

	showModal(){		//calling from external
		this.createModal();
		modalDiv.classList.add('modal_open');
		this.state.isHidden = false;
		this.renderWindow();
	}
	hideEvent(e){
		if(e.target === modalDiv) this.hideModal();
	}
	hideModal(){
		modalDiv.classList.remove('modal_open');
		modalDiv.innerHTML = '';
		this.state.isHidden = true;
		this.renderWindow();
	}
	toggleModal(){
		if(this.modalOpen){
			hideModal();
		} else {
			showModal();
		}
	}
	
	renderWindow() {
		if (this.state.isHidden) {
			dialog.style.display = 'none';
		} else {
			dialog.style.display = 'block';
		}
		dialog.style.top = this.state.y + 'px';
		dialog.style.left = this.state.x + 'px';
		//console.log(this.state.y);
	}
	onMouseMove(e) {
		if (this.state.isDragging) {
			let clampXbind = clampX.bind(this);
			let clampYbind = clampY.bind(this);
			this.state.x = clampXbind(e.pageX - this.state.xDiff);
			this.state.y = clampYbind(e.pageY - this.state.yDiff);
		}

		// Update window position
		//var w = document.getElementById('modal_dialog');
		this.renderWindow();
	}


}


function ready(fn) {
    if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading"){
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}


function clampX(n) {
    return Math.min(Math.max(n, 0), modalDiv.clientWidth - this.state.width);
                    // container width - window width
                    //500 - 400);
	//return n;
}

function clampY(n) {
    return Math.min(Math.max(n, 0), modalDiv.clientHeight - document.getElementById('modal_bar').clientHeight);//800);
	//return n;
}

function onMouseDown(e) {
    this.state.isDragging = true;
    this.state.xDiff = e.pageX - this.state.x;
    this.state.yDiff = e.pageY - this.state.y;
}

function onMouseUp() {
    this.state.isDragging = false;
	if(!this.state.isHidden){
		this.state.width = dialog.clientWidth;
		this.state.height = dialog.clientHeight;
		dialog.style.width = this.state.width + 'px';
		dialog.style.height = this.state.height + 'px';
	}
	//console.log(dialog.getBoundingClientRect());
	//console.log(this.state);
}


